import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { OrganizationInviteStatusDto } from "../../autogen/bff-api";

export const OrgInviteStatusTag = ({ status }: { status: OrganizationInviteStatusDto }) => {
  const { t } = useTranslation();

  const tagMeta = (): { color: string; text: string } => {
    switch (status) {
      case OrganizationInviteStatusDto.Accepted:
        return { color: "green", text: t("Accepted") };
      case OrganizationInviteStatusDto.Declined:
        return { color: "red", text: t("Declined") };
      case OrganizationInviteStatusDto.Invited:
        return { color: "gray", text: t("Invited") };
    }
  };

  const { color, text } = tagMeta();

  return (
    <Tag colorScheme={color} size="sm" textAlign="center" height="8" py="2">
      {text}
    </Tag>
  );
};
